import { getGuardId, memo } from '@morphic-ts/common/es6/utils';
import { EqType, EqURI } from './../hkt';
/**
 *  @since 0.0.1
 */
export const eqUnionInterpreter = memo(() => ({
    _F: EqURI,
    union: items => (guards, _name) => (env) => {
        const items_ = items.map(_ => _(env).eq.equals);
        const guardId = getGuardId(guards, Symbol());
        return new EqType({
            equals: (a, b) => {
                if (a === b) {
                    return true;
                }
                const iA = guardId(a);
                return iA === guardId(b) && items_[iA](a, b);
            }
        });
    }
}));
